import React from 'react';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section className="w-full bg-white py-20 lg:py-28" aria-labelledby="pain-heading" data-id="element-139" data-mp="2ln2gqbo55hr2">
      <div className="mx-auto max-w-content px-6" data-id="element-140" data-mp="26yfqhewz75l2">
        <div className="max-w-2xl" data-id="element-141" data-mp="26xmpkukp7aau">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-flare-600" data-id="element-142" data-mp="26wleiq3omnt4">
            El punto de partida
          </p>
          <h2 id="pain-heading" className="mt-3 text-3xl font-black leading-tight tracking-tight text-ink-950 sm:text-4xl" data-id="element-143" data-mp="1xxhvtn8fgaf5">
            ¿Por qué la mayoría de principiantes fracasan con drones?
          </h2>
        </div>

        <div className="mt-12 grid gap-px overflow-hidden rounded-xl bg-ink-200 sm:grid-cols-2 lg:grid-cols-4" data-id="element-144" data-mp="1o0vakxc6vhcl">
          {painPoints.map(point => {
          const Icon = point.icon;
          return <article key={point.id} className="flex h-full flex-col bg-white p-7 ring-1 ring-ink-950/10" data-id="element-145" data-mp="3iewazmne0ces">
                <Icon className="h-7 w-7 text-flare-600" aria-hidden="true" data-id="element-146" data-mp="3nc5wir7no3xc" />
                <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.14em] text-flare-600" data-id="element-147" data-mp="1yzn3xk05p8g3">
                  {point.kicker}
                </p>
                <h3 className="mt-2 text-lg font-bold leading-snug text-ink-950" data-id="element-148" data-mp="1tzr9abdcmtd7">{point.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-600" data-id="element-149" data-mp="27utcuruq46mu">{point.body}</p>
                <div className="mt-auto pt-6" data-id="element-150" data-mp="23thun7e6inoo">
                  <p className="text-2xl font-black tracking-tight text-ink-950" data-id="element-151" data-mp="1g11408gdlndr">{point.stat}</p>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-500" data-id="element-152" data-mp="1b3hpd7frn8la">
                    {point.statLabel}
                  </p>
                  <p className="mt-4 border-t border-ink-950/10 pt-4 text-sm font-semibold leading-snug text-ink-700" data-id="element-153" data-mp="1p04nvenda6tb">
                    {point.solution}
                  </p>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}